import { DetailsCompProps } from '../../Interfaces/Props';

const DetailsComp = (props: DetailsCompProps) => {
  return (
    <div className={props.className}>
      <details className="p-4 [&_svg]:open:-rotate-180">
        <summary className="flex cursor-pointer list-none items-center gap-4">
          <div>
            <svg
              className="rotate-0 transform text-primary transition-all duration-300"
              fill="none"
              height="24"
              width="24"
              stroke="currentColor"
              strokeLinecap="round"
              strokeLinejoin="round"
              strokeWidth="2"
              viewBox="0 0 24 24"
            >
              <polyline points="6 9 12 15 18 9"></polyline>
            </svg>
          </div>
          <p>{props.title ?? 'Open Description'}</p>
        </summary>
        <div className="my-2">{props.children}</div>
      </details>
    </div>
  );
};

export default DetailsComp;
